import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'

const PrefectureSummaryCards = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white p-6 rounded-lg shadow animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-2"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { summary } = data

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-sm text-gray-600 mb-2">総試合数</p>
        <p className="text-2xl font-bold text-gray-900">{summary.totalMatches.toLocaleString()}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-sm text-gray-600 mb-2">勝率</p>
        <p className="text-2xl font-bold text-gray-900">{summary.winRate.toFixed(1)}%</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-sm text-gray-600 mb-2">優勝回数</p>
        <p className="text-2xl font-bold text-gray-900">{summary.championships}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-sm text-gray-600 mb-2">準優勝回数</p>
        <p className="text-2xl font-bold text-gray-900">{summary.runnersUp}</p>
      </div>
    </div>
  )
}

export default PrefectureSummaryCards

